import React, { useEffect, useState } from 'react';

import { Header } from "../../components/Header";
import { Container, Content, TitleDate, InfoCard, Button, ButtonSwitch, SwitchContainer } from "./styles"
import Switch from 'react-switch'; 

import { useAuth } from '../../contexts/AuthContexts';
import { useUser, track } from '../../contexts/UserContexts';
import { db } from '../../firebase';
import { getDoc, doc, setDoc } from "firebase/firestore";

import appleIcon from "../../assets/icon-apple.svg";
import fireIcon from "../../assets/icon-fire.svg"
import cardioIcon from "../../assets/cardio.png"


import { useNavigate } from "react-router-dom";

export const Track = () => {

    const [ trainCheck, setTrainCheck ] = useState(false);
    const [ dietCheck, setDietCheck ] = useState(false);
    const [ cardioCheck, setCardioCheck ] = useState(false);
    const [ selectedWeekDay, setSelectedWeekDay ] = useState(0);
    const week = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"]
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState("");
    const [ sucess, setSucess ] = useState("");
    
    
    const { currentUser } = useAuth();
    const { userInfo, track } = useUser();
    const history = useNavigate();
    
    const d = new Date();

    const handleTrack = async () => {
        if(!currentUser || !currentUser.uid) return;

        const init = new Date("February, 28, 2022").getTime();

        if(d < init){
            setError("Projeto ainda não começou");
            return;
        }

        setError("");
        setSucess("");
        setLoading(true);
        try {
            await track(dietCheck, trainCheck, cardioCheck, selectedWeekDay);

            setSucess("Marcado com sucesso Fella!")
        } catch(e) {
            setError(e);
        }
        
        setLoading(false);
    };


    const getInfoFromContext = async (idx) => {
        if(!currentUser || !currentUser.uid) return;

        setLoading(true);

        setSelectedWeekDay(idx);

        const currentDate = new Date();
        const currentWeek = new Date(currentDate.setDate(currentDate.getDate() - (currentDate.getDay() + 6)%7));

        const date = currentWeek;
        date.setDate(date.getDate() + idx);
        const isoDate = String(date.getFullYear() + "-" + String(parseInt(date.getMonth() + 1)).padStart(2, '0') + "-" + String(date.getDate()).padStart(2, '0'));

        setDietCheck(userInfo.dietDaysMap[isoDate] || false);
        setTrainCheck(userInfo.trainingDaysMap[isoDate] || false);
        setCardioCheck(userInfo.cardioDaysMap[isoDate] || false);

        setLoading(false);
    };

    const handleWeekSelection = (idx) => {
        getInfoFromContext(idx);
    };

    useEffect(() => {
        getInfoFromContext(selectedWeekDay);
    }, []);

    return(
        <Container>
            <Header />
            <Content>
                {/* <TitleDate>{ String(d.getDate()).padStart(2, '0') + " de " + months[d.getMonth()] + " de " + d.getFullYear() }</TitleDate> */}
                <TitleDate>Track</TitleDate>
                <InfoCard>
                    {week.map((week, idx) => (
                        <ButtonSwitch
                            key={idx}
                            style={{"backgroundColor": selectedWeekDay === idx ? "#FFF" : "transparent", "boxShadow": selectedWeekDay === idx ? "0px 0px 5px rgba(0,0,0,.2)" : "0px 0px 0px rgba(0,0,0,.2)"}}
                            onClick={() => handleWeekSelection(idx)}
                            disabled={d.getDay() == 0 ? false : idx >= d.getDay()}
                        >{week}</ButtonSwitch>
                    ))}
                </InfoCard>
                <div className='category'>Atividade</div>
                <SwitchContainer>
                    <div className='switchContent'>
                        <div className='iconGroup'>
                            <img src={fireIcon} alt="fire" />
                            <div className='iconGroupTitle' style={{"color":"#FF4704"}}>Treino</div>
                        </div>
                        <Switch
                            onChange={() => setTrainCheck(!trainCheck)} 
                            checked={trainCheck} 
                            onColor="#34c759"
                            onHandleColor="#fff"
                            uncheckedIcon={false}
                            checkedIcon={false}
                        />
                    </div>
                    <div style={{"backgroundColor": "#C1C1C1", "width": "100%", "height": "1px", "fontSize": "1px", "lineHeight": "1px"}}> </div>
                    <div className='switchContent'>
                        <div className='iconGroup'>
                            <img src={appleIcon} alt="apple" />
                            <div className='iconGroupTitle' style={{"color":"#FA124F"}}>Dieta</div>
                        </div>
                        <Switch
                            onChange={() => setDietCheck(!dietCheck)} 
                            checked={dietCheck} 
                            onColor="#34c759"
                            onHandleColor="#fff"
                            uncheckedIcon={false}
                            checkedIcon={false}
                        />
                    </div>
                    <div style={{"backgroundColor": "#C1C1C1", "width": "100%", "height": "1px", "fontSize": "1px", "lineHeight": "1px"}}> </div>
                    <div className='switchContent'>
                        <div className='iconGroup'>
                            <img src={cardioIcon} width="20px" alt="apple" />
                            <div className='iconGroupTitle' style={{"color":"#FA124F"}}>Cardio</div>
                        </div>
                        <Switch
                            onChange={() => setCardioCheck(!cardioCheck)} 
                            checked={cardioCheck} 
                            onColor="#34c759"
                            onHandleColor="#fff"
                            uncheckedIcon={false}
                            checkedIcon={false}
                        />
                    </div>
                </SwitchContainer>
                <Button disabled={loading} onClick={ handleTrack }> {dietCheck && trainCheck && cardioCheck ? "Modo CHAD" : "Marcar"} </Button>
                {error}
                {sucess}
            </Content>
        </Container>
    );
};